(function ClientIndex($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		$(".client-links").on('click', function showLinkedClients(e)
		{
			e.preventDefault();
			alert('NYI - will show a modal or something');
		});
	});
}(jQuery, window.Adzuki || {}));